import React from 'react'

function Atmosphere() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 20 20"
        >
            <g fill="currentColor">
                <path d="M12.5 13.817c.759 0 1.025.275 1.034 1.05a.616.616 0 00.608.617.625.625 0 00.625-.592c.042-.892.425-1.075 1.025-1.075a.625.625 0 000-1.25c-.783 0-1.058-.283-1.058-1.033a.625.625 0 00-.625-.634.633.633 0 00-.625.625c0 .759-.275 1.034-1.05 1.042a.633.633 0 00-.617.633.625.625 0 00.683.617zM.633 5.833c2.7 0 3.925 1.225 3.95 3.967a.625.625 0 001.25.025C5.967 7.1 7.217 5.833 9.758 5.833a.625.625 0 100-1.25C7.092 4.525 5.833 3.275 5.833.633a.625.625 0 10-1.25-.008C4.575 3.283 3.333 4.55.617 4.583A.633.633 0 000 5.217a.625.625 0 00.625.616h.008z"></path>
                <path d="M10 0a9.8 9.8 0 00-1 .05.837.837 0 10.167 1.667H10A8.334 8.334 0 115.983 17.3a.217.217 0 01-.108-.158.233.233 0 01.058-.175l3.65-3.634a.2.2 0 000-.291l-1.983-2a.217.217 0 00-.292 0l-3.816 3.816a.15.15 0 01-.142.05.182.182 0 01-.133-.075A8.333 8.333 0 011.667 10c-.013-.25-.013-.5 0-.75A.837.837 0 000 9.092V10A10 10 0 1010 0z"></path>
                <path d="M12.567 10.333a1.066 1.066 0 000-1.516l-.759-.759a1.075 1.075 0 00-1.516 0l-2.1 2.1a.208.208 0 000 .3l1.983 1.975a.2.2 0 00.292 0l2.1-2.1z"></path>
            </g>{' '}
        </svg>
    )
}

export default Atmosphere
